var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "user"
  }, [_c('div', {
    staticClass: "card-body1"
  }, [_c('legend', [_c('center', [_vm._v(" B2B Shipments \n            "), _c('span', {
    staticClass: "RedirectIconCss",
    attrs: {
      "title": "Click to Redirect B2B Portal"
    },
    on: {
      "click": _vm.redirectToB2bPortal
    }
  }, [_c('i', {
    staticClass: "fa fa-share-square-o IconSize"
  })])])], 1), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('div', {
    staticClass: "B2BCardCss"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.CardLoader
    },
    on: {
      "update:active": function($event) {
        _vm.CardLoader = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Business Unit :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-cog'></i>"
    }
  }, [_c('b-input-group', [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.BusinessUnitsList,
      "selected-option": _vm.BusinessUnitItemObj,
      "name": "BusinessUnit",
      "placeholder": "Select"
    },
    on: {
      "select": _vm.getBusinessUnits
    },
    model: {
      value: (_vm.BusinessUnit),
      callback: function($$v) {
        _vm.BusinessUnit = $$v
      },
      expression: "BusinessUnit"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('BusinessUnit')),
      expression: "errors.has('BusinessUnit')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('BusinessUnit')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Client :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>",
      "right": _vm.srLoader
    }
  }, [_c('b-input-group', [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.clientList,
      "selected-option": _vm.clientItemObj,
      "name": "client",
      "placeholder": "Select client"
    },
    on: {
      "select": _vm.getclients
    },
    model: {
      value: (_vm.client),
      callback: function($$v) {
        _vm.client = $$v
      },
      expression: "client"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('client')),
      expression: "errors.has('client')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('client')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Delivery User :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>",
      "right": _vm.srLoader
    }
  }, [_c('b-input-group', [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.srList,
      "selected-option": _vm.srItemObj,
      "name": "SR",
      "placeholder": "Select SR"
    },
    on: {
      "select": _vm.getSRs
    },
    model: {
      value: (_vm.srId),
      callback: function($$v) {
        _vm.srId = $$v
      },
      expression: "srId"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('SR')),
      expression: "errors.has('SR')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('SR')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-4"
  }, [_c('span', {
    staticClass: "btn btn-danger ResetBtn",
    on: {
      "click": function($event) {
        return _vm.Reset()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-undo"
  }), _vm._v(" Reset ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row B2BShipments"
  }, [_c('div', {
    staticClass: "col-xl-2 col-sm-6 py-2"
  }, [_c('div', {
    staticClass: "card bg-success text-white CardsCss",
    attrs: {
      "title": "Click to Redirect B2B Portal"
    },
    on: {
      "click": _vm.redirectToB2bPortal
    }
  }, [_c('div', {
    staticClass: "card-body Allocated"
  }, [_c('div', {
    staticClass: "rotate"
  }, [_c('i', {
    staticClass: "fa fa-edit fa-4x IconCss",
    on: {
      "click": _vm.redirectToB2bPortal
    }
  })]), _vm._v(" "), _c('h6', {
    staticClass: "text-uppercase"
  }, [_vm._v("Allocate to SR")]), _vm._v(" "), _c('h2', {
    staticClass: "ShipmentsCount"
  }, [_vm._v(_vm._s(_vm.SRallocatedCount))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-2 col-sm-6 py-2"
  }, [_c('div', {
    staticClass: "card bg-success text-white CardsCss",
    attrs: {
      "title": "Click to Redirect B2B Portal"
    },
    on: {
      "click": _vm.redirectToB2bPortal
    }
  }, [_c('div', {
    staticClass: "card-body OFD"
  }, [_c('div', {
    staticClass: "rotate"
  }, [_c('i', {
    staticClass: "fa fa-motorcycle fa-4x IconCss"
  })]), _vm._v(" "), _c('h6', {
    staticClass: "text-uppercase"
  }, [_vm._v("OFD")]), _vm._v(" "), _c('h2', {
    staticClass: "ShipmentsCount"
  }, [_vm._v(_vm._s(_vm.OfdCount))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-2 col-sm-6 py-2"
  }, [_c('div', {
    staticClass: "card bg-success text-white CardsCss",
    attrs: {
      "title": "Click to Redirect B2B Portal"
    },
    on: {
      "click": _vm.redirectToB2bPortal
    }
  }, [_c('div', {
    staticClass: "card-body Delivery"
  }, [_c('div', {
    staticClass: "rotate"
  }, [_c('i', {
    staticClass: "fa fa-dropbox fa-4x IconCss"
  })]), _vm._v(" "), _c('h6', {
    staticClass: "text-uppercase"
  }, [_vm._v("Delivery")]), _vm._v(" "), _c('h2', {
    staticClass: "ShipmentsCount"
  }, [_vm._v(_vm._s(_vm.deliveryCount))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-2 col-sm-6 py-2"
  }, [_c('div', {
    staticClass: "card bg-success text-white CardsCss",
    attrs: {
      "title": "Click to Redirect B2B Portal"
    },
    on: {
      "click": _vm.redirectToB2bPortal
    }
  }, [_c('div', {
    staticClass: "card-body NDR"
  }, [_c('div', {
    staticClass: "rotate"
  }, [_c('i', {
    staticClass: "fa fa-times-circle fa-4x IconCss"
  })]), _vm._v(" "), _c('h6', {
    staticClass: "text-uppercase"
  }, [_vm._v("NDR")]), _vm._v(" "), _c('h2', {
    staticClass: "ShipmentsCount"
  }, [_vm._v(_vm._s(_vm.NdrCount))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-2 col-sm-6 py-2"
  }, [_c('div', {
    staticClass: "card bg-success text-white CardsCss",
    attrs: {
      "title": "Click to Redirect B2B Portal"
    },
    on: {
      "click": _vm.redirectToB2bPortal
    }
  }, [_c('div', {
    staticClass: "card-body PODPending"
  }, [_c('div', {
    staticClass: "rotate1"
  }, [_c('i', {
    staticClass: "fa fa-files-o fa-4x IconCss"
  })]), _vm._v(" "), _c('h6', {
    staticClass: "text-uppercase"
  }, [_vm._v("POD Pending")]), _vm._v(" "), _c('h2', {
    staticClass: "ShipmentsCount"
  }, [_vm._v(_vm._s(_vm.PODPendingCount))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-2 col-sm-6 py-2"
  }, [_c('div', {
    staticClass: "card bg-success text-white CardsCss",
    attrs: {
      "title": "Click to Redirect B2B Portal"
    },
    on: {
      "click": _vm.redirectToB2bPortal
    }
  }, [_c('div', {
    staticClass: "card-body PODConnected"
  }, [_c('div', {
    staticClass: "rotate1"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o fa-4x IconCss"
  })]), _vm._v(" "), _c('h6', {
    staticClass: "text-uppercase"
  }, [_vm._v("POD Connected")]), _vm._v(" "), _c('h2', {
    staticClass: "ShipmentsCount"
  }, [_vm._v(_vm._s(_vm.PODConnectedCount))])])])])])], 1)])])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c18d08c8","hasScoped":true}!./src/views/components/B2BCargoDashboard/B2BCargoDashboard.component.html
// module id = 1479
// module chunks = 1